import { Application, Controller } from "stimulus"


export default class CalendarWeekController extends Controller {
  
  monthsLoaded = [];
  selectedDay;
  currentDate;
  lastDate;
  calendarView = "week";
  submitModificationBtn = document.querySelector('[data-submit-modification-btn="true"]')

  static targets = [
    "calendarContainer", "horizontalCalendar", "monthName", "weekDays", "dayHeader",
    "eventsContainer", "dayContainer", "chevronDown", "chevronLeft", "chevronRight", "showMoreEvents",
    "bottomWrapper", "modificationDate", "modificationHour", "modificationLanguage", "modificationListingId"
  ]

  static values = { currentDate: String, eventDays: Object, events: Object, flagsImg: Object,
                    labels: Object, tour: String, attendance: String, bookingModification: { default: false, type: Boolean },
                    tourPro: Boolean 
                  }
  
  connect() {
    this.currentDate = this.currentDateValue || gon.moment();
    this.dayWidth = Math.floor(this.weekDaysTarget.querySelector("div").getBoundingClientRect().width * 100) / 100;
    this.dayWidth = this.dayWidth == 0 ? 45 : this.dayWidth;
    this.renderEvents(this.currentDate);
    this.renderHorizontalCalendar(this.currentDate, false);
    this.handleDragEvents();
    this.selectDayHandler(this.selectedDay);
  }

  renderHorizontalCalendar(monthDate, before) {
    this.monthsLoaded.push(gon.moment(monthDate).format('YYYY-MM-01'));
    this.renderSelectableDays(monthDate, before);
  }

  showCurrentWeek(currentDate = this.currentDate) {
    var startDate = gon.moment(currentDate).locale(gon.locale).startOf('week').format('YYYY-MM-DD');
    var endDate = gon.moment(currentDate).locale(gon.locale).endOf('week').format('YYYY-MM-DD');
    this.showCurrentDays(startDate, endDate, currentDate);
  }

  showCurrentMonth(currentDate = this.currentDate) {
    var startDate = gon.moment(currentDate).locale(gon.locale).startOf('month').startOf('week').format('YYYY-MM-DD');
    var endDate = gon.moment(currentDate).locale(gon.locale).endOf('month').endOf('week').format('YYYY-MM-DD');
    this.showCurrentDays(startDate, endDate, currentDate);
  }

  showCurrentDays(startDate, endDate, currentDate) {
    var startMonthDate = gon.moment(currentDate).locale(gon.locale).startOf('month').format('YYYY-MM-DD');
    var endMonthDate = gon.moment(currentDate).locale(gon.locale).endOf('month').format('YYYY-MM-DD');
    this.horizontalCalendarTarget.querySelectorAll(`div[data-item=calendarDay]`).forEach((dayContainer) => {
      var testDate = gon.moment(dayContainer.dataset.date);
      dayContainer.classList.add("d-none");
      dayContainer.classList.remove("other-month");
      if (testDate.isBetween(startDate, endDate, 'days', true)) {
        dayContainer.classList.remove("d-none");
        if (!testDate.isBetween(startMonthDate, endMonthDate, 'days', true) && !this.calendarViewWeek()) {
          dayContainer.classList.add("other-month");
        }
      }
    });
  }
  
  renderMonthHeader(currentDate = this.currentDate) {
    var year = gon.moment(currentDate).format('YYYY');
    var monthName = gon.moment(currentDate).locale(gon.locale).format('MMMM')
    this.monthNameTarget.textContent = `${monthName} ${year}`;
  }

  renderDayHeader() {
    var today = gon.moment().format('YYYY-MM-DD');
    var selectedDay = gon.moment(this.currentDate).format('D');
    var monthNameShort = gon.moment(this.currentDate).locale(gon.locale).format('MMM')
    var year = gon.moment(this.currentDate).format('YYYY');
    var dayLabel = this.currentDate == today ? this.labelsValue.today : gon.moment(this.currentDate).locale(gon.locale).format('ddd').replace(/\./g,''); 
    this.dayHeaderTarget.textContent = `${dayLabel}, ${selectedDay} ${monthNameShort} ${year}`;
  }

  renderDay(date) {
    var newDiv = document.createElement("div");
    var day = date.format('D');
    var newContent = document.createTextNode(day);
    newDiv.style.minWidth = this.dayWidth;
    newDiv.style.minHeight = this.dayWidth;
    newDiv.classList.add("calendar-day");
    newDiv.appendChild(newContent);
    newDiv.dataset.item = "calendarDay";
    newDiv.dataset.date = date.format('YYYY-MM-DD');
    return newDiv;
  }

  renderSelectableDays(monthDate, before) {
    var startDate = gon.moment(monthDate).locale(gon.locale).startOf('month').startOf('week').format('YYYY-MM-DD');
    var endDate = gon.moment(monthDate).locale(gon.locale).endOf('month').endOf('week').format('YYYY-MM-DD');
    this.renderSideDays(startDate, endDate, before)
  }

  renderSideDays(startDate, endDate, before) {
    before == true ? this.renderPreviousDays(startDate, endDate, before) : this.renderNextDays(startDate, endDate, before);
  }

  renderNextDays(startDate, endDate, before) {
    for (var date = gon.moment(startDate); date.diff(endDate, 'days') <= 0; date.add(1, 'days')) {
      this.renderDays(date, before)
    }
  }

  renderPreviousDays(startDate, endDate, before) {
    for (var date = gon.moment(endDate); date.diff(startDate, 'days') >= 0; date.subtract(1, 'days')) {
      this.renderDays(date, before)
    }
  }
  
  renderDays(date, before) {
    var dayDate = date.format('YYYY-MM-DD');
    var renderedDayDiv = this.horizontalCalendarTarget.querySelector(`div[data-item=calendarDay][data-date='${dayDate}']`);
    var renderedDayDivCondition = this.horizontalCalendarTarget.querySelector(`div[data-item=calendarDay][data-date='${dayDate}']`) != undefined;
    if (!renderedDayDivCondition) {
      var newDiv = this.renderDay(date);
      this.setSelectableDay(dayDate, newDiv);
      this.addDayToCalendar(newDiv, before);
    }else{
      renderedDayDiv.classList = "calendar-day";
      this.setSelectableDay(dayDate, renderedDayDiv);
    }    

  }

  setSelectableDay(dayDate, newDiv) {
    if (this.availableEvents(dayDate)) { 
      newDiv.classList.add("selectable");
      if (this.lowAvailabilityEvent(dayDate)) {
        newDiv.classList.add("selectable-half");
      }
    }else if(dayDate >= gon.moment().format('YYYY-MM-DD')){
      if (this.availableFullEvents(dayDate)) {
        newDiv.classList.add("selectable-full");
      }else {
        newDiv.classList.add("selectable-empty");
      }
    }
    if(gon.moment(dayDate) >= gon.moment(this.currentDate)) {
      this.selectedDay = this.selectedDay || newDiv;
    }
    if(dayDate >= gon.moment().format('YYYY-MM-DD')) {
      newDiv.addEventListener("click", (e) => { this.selectDayHandler(e.target) })
    }
  }

  lowAvailabilityEvent(dayDate) {
    var eventsDayDate = this.eventDaysValue[dayDate];
    if(eventsDayDate.find(event => (event.available_seats > 0 && event.capacity_seats > 0) && (event.available_seats * 100)/event.capacity_seats < 20)){
      return true;
    }
    return false;
  }

  availableFullEvents(dayDate) {
    var eventsDayDate = this.eventDaysValue[dayDate];
    if(eventsDayDate != undefined && eventsDayDate.find(event => event.available_seats == 0 && event.open_events > 0)) {
      return true;
    }
    return false;
  }

  availableEvents(dayDate) {
    var eventsDayDate = this.eventDaysValue[dayDate];
    return eventsDayDate != undefined && this.checkBlockedDay(eventsDayDate)
  }

  checkBlockedDay(events) {
    var bookableEvent = events.find(event => event.available_events > 0);
    return bookableEvent != null;
  }

  addDayToCalendar(newDiv, before) {
    before == true ? this.horizontalCalendarTarget.prepend(newDiv) : this.horizontalCalendarTarget.append(newDiv);
  }

  selectDayHandler(dayDiv) {
    this.showEventsDay(dayDiv);
    this.selectDayCalendar(dayDiv);
    this.selectedDay = dayDiv;
    this.currentDate = dayDiv.dataset.date;
    this.lastDate = this.currentDate;
    this.displayShowMoreEvents();
    this.renderDayHeader();
    this.renderMonthHeader();
    this.setCalendarWeekView();
    this.availableScrollDaysLeft();
    this.availableScrollDaysRight();
    this.eventsContainerTarget.scrollTo(0,0);
    this.trackClick();
  }

  trackClick() {
    var events = this.eventsValue[this.currentDate];
    var event_body = { tour_id: this.tourValue,
                       day: this.currentDate,
                       events: [] }

    if (events != undefined) {
      events.forEach((event) => {
        if (event.available == true) {
          event_body.events.push({ language: event.language,
                                   available: event.available,
                                   begins_time: event.begins_time,
                                   ends_time: event.ends_time,
                                   last_seats: event.last_seats });
        }
      });
    }
    this.sendTracking(event_body);
  }

  async sendTracking(data) {
    fetch("/tracking/tour_calendar_show_days", { method: 'post',
                                                 body: JSON.stringify(data),
                                                 headers: { 'Content-Type': 'application/json',
                                                            'X-CSRF-Token': Rails.csrfToken()
                                                          },
                                                 credentials: 'same-origin'
                                               });
  }

  showEventsDay(dayDiv) {
    this.eventsContainerTarget.querySelectorAll(".events-day").forEach((dayContainer) => {
      dayContainer.dataset.date != dayDiv.dataset.date ?  dayContainer.classList.add("d-none") : dayContainer.classList.remove("d-none");
    });
  }

  selectDayCalendar(dayDiv) {
    this.unselectDayCalendar();
    this.selectNewDayCalendar(dayDiv);
  }

  selectNewDayCalendar(dayDiv) {
    dayDiv.classList.remove("selectable");
    dayDiv.classList.add("selected");
  }

  unselectDayCalendar(dayDiv) {
    this.selectedDay.classList.remove("selected");
    this.selectedDay.classList.add("selectable");
  }

  handleDragEvents() {
    this.horizontalCalendarTarget.addEventListener("touchstart", (e) => { this.touchScrollStartEvent(e); })
    this.horizontalCalendarTarget.addEventListener("touchmove", (e) => { this.touchScrollMoveEvent(e); })
    this.horizontalCalendarTarget.addEventListener("touchend", (e) => { this.touchScrollEndEvent(e); });
  }
  
  availableScrollDaysLeft() {
    var currentDate = this.horizontalCalendarTarget.querySelector(`div[data-item=calendarDay]:not(.d-none)`).dataset.date;
    var startDate = gon.moment(currentDate).locale(gon.locale).format('YYYY-MM-DD');
    if (startDate <= gon.moment().format('YYYY-MM-DD')){
      this.chevronLeftTarget.classList.add('disabled-icon');
      return false;
    }
    this.chevronLeftTarget.classList.remove('disabled-icon');
    return true;
  }

  availableScrollDaysRight() {
    const calendarDays = this.horizontalCalendarTarget.querySelectorAll(`div[data-item=calendarDay]:not(.d-none)`);
    const currentDate = calendarDays[calendarDays.length-1].dataset.date;
    const endDate = gon.moment(currentDate).locale(gon.locale).format('YYYY-MM-DD');
    let maxGuruProDate = this.tourProValue ? gon.moment().add(1, 'years') : gon.moment().add(6, 'months');
    const maxGuruDate = maxGuruProDate.format('YYYY-MM-DD');
    if (endDate >= maxGuruDate){
      this.chevronRightTarget.classList.add('disabled-icon');
      return false;
    }
    this.chevronRightTarget.classList.remove('disabled-icon');
    return true;
  }

  changeWeek(weeks, currentDate) {
    var selectedDayDate = gon.moment(currentDate).locale(gon.locale).add(weeks, 'weeks').startOf('week').format('YYYY-MM-DD');
    this.renderMonthHeader(selectedDayDate);
    this.showCurrentWeek(selectedDayDate);
  }

  scrollLeftEvent() {
    if (this.availableScrollDaysLeft()) {
      var currentDate;
      if (this.calendarViewWeek()) {
        currentDate = this.horizontalCalendarTarget.querySelector(`div[data-item=calendarDay]:not(.d-none)`).dataset.date
        this.loadPreviousMonth(() => {
          this.changeWeek(-1, currentDate);
          this.availableScrollDaysLeft();
        }, currentDate);
      } else {
        currentDate = this.horizontalCalendarTarget.querySelectorAll(`div[data-item=calendarDay]:not(.d-none)`)[7].dataset.date
        var selectedDayDate = gon.moment(currentDate).add(-1, 'months').format('YYYY-MM-01');
        this.loadPreviousMonth(() => {
          this.renderMonthHeader(selectedDayDate);
          this.showCurrentMonth(selectedDayDate);
          this.availableScrollDaysLeft();
        }, selectedDayDate);
      }
      this.lastDate = currentDate;
      this.chevronRightTarget.classList.remove('disabled-icon');
    }
  }

  scrollRightEvent() {
    if(this.availableScrollDaysRight()) {
      var currentDate;
      if (this.calendarViewWeek()) {
        currentDate = this.horizontalCalendarTarget.querySelector(`div[data-item=calendarDay]:not(.d-none)`).dataset.date
        this.loadNextMonth(() => { 
          this.changeWeek(1, currentDate);
          this.availableScrollDaysRight();
        }, currentDate);
      } else {
        currentDate = this.horizontalCalendarTarget.querySelectorAll(`div[data-item=calendarDay]:not(.d-none)`)[7].dataset.date
        var selectedDayDate = gon.moment(currentDate).add(1, 'months').format('YYYY-MM-01');
        this.loadNextMonth(() => { 
          this.renderMonthHeader(selectedDayDate);
          this.showCurrentMonth(selectedDayDate);
          this.availableScrollDaysRight();
        }, selectedDayDate);
      }
      this.lastDate = currentDate;
      this.chevronLeftTarget.classList.remove('disabled-icon');
    }
  }

  loadPreviousMonth(callback = ()=>{}, currentDate = this.currentDate) {
    var monthPreviousDate = gon.moment(currentDate).add(-1, 'months').format('YYYY-MM-01');
    var monthDate = gon.moment(currentDate).format('YYYY-MM-01');
    var currentMonthDate = gon.moment().format('YYYY-MM-01')
    if(this.monthsLoaded.indexOf(monthPreviousDate) < 0 && (monthPreviousDate >= currentMonthDate || monthDate >= currentMonthDate || !this.calendarViewWeek())){
      this.fetchEventData(monthDate, true, callback);
    }else {
      callback();
    }
  }

  loadNextMonth(callback = ()=>{}, currentDate = this.currentDate) {
    var monthDate = gon.moment(currentDate).add(1, 'months').format('YYYY-MM-01');
    if(this.monthsLoaded.indexOf(monthDate) < 0){
      this.fetchEventData(monthDate, false, callback);
    }else{
      callback();
    }
  }

  touchScrollMoveEvent(event) {
    this.moveScrollX = event.changedTouches[0].pageX;
  }

  touchScrollStartEvent(event) {
    this.initalScrollX = event.changedTouches[0].pageX;
  }

  touchScrollEndEvent(event){
    var endScrollX = event.changedTouches[0].pageX;
    if (this.initalScrollX != endScrollX && endScrollX == this.moveScrollX) {
      this.initalScrollX > endScrollX ? this.scrollRightEvent() : this.scrollLeftEvent();
    }
  }

  mouseoverEventContainerHandler() {
    this.eventsContainerTarget.classList.remove("bottom-blur")
    this.eventsContainerTarget.classList.remove("with-blur")
  }

  mouseoutEventContainerHandler() {
    this.eventsContainerTarget.classList.add("bottom-blur")
    this.eventsContainerTarget.classList.add("with-blur")
  }

  renderEvents(monthDate) {
    var startDate = gon.moment(monthDate).locale(gon.locale).startOf('month').startOf('week').format('YYYY-MM-DD');
    var endDate = gon.moment(monthDate).locale(gon.locale).endOf('month').endOf('week').format('YYYY-MM-DD');
    for (var date = gon.moment(startDate); date.diff(endDate, 'days') <= 0; date.add(1, 'days')) {
      var dayDate = date.format('YYYY-MM-DD');
      var dayEventsDiv = this.renderDayEvents(dayDate);
      var renderedEventDayDiv = this.calendarContainerTarget.querySelector(`.events-day[data-date='${dayDate}']`);
      var renderedEventDayDivCondition = this.calendarContainerTarget.querySelector(`.events-day[data-date='${dayDate}']`) == null;
      if(!renderedEventDayDivCondition) {
        renderedEventDayDiv.remove();
      }
      var events = this.eventsValue[dayDate];
      if (events != undefined) {
        dayEventsDiv.append(this.renderDayAvailableContainer(events, true));
        dayEventsDiv.append(this.renderDayAvailableContainer(events, false));
      }else {
        dayEventsDiv.append(this.emptyState());
      }
      this.eventsContainerTarget.append(dayEventsDiv);
      if(dayDate != gon.moment(this.currentDate)) { dayEventsDiv.classList.add("d-none") };
      this.eventsContainerTarget.append(dayEventsDiv);
    }
  }

  emptyState() {
    var elementP = document.createElement("p");
    elementP.classList.add('empty-state-text');
    elementP.innerText = this.labelsValue.calendar.empty_state;
    return elementP;
  }

  renderDayEvents(date){
    var dayEventsDiv = document.createElement("div");
    dayEventsDiv.classList.add('events-day');
    dayEventsDiv.dataset.date = date;
    return dayEventsDiv;
  }

  renderDayAvailableContainer(events, available) {
    var availabilityContainer = document.createElement("div");
    availabilityContainer.classList.add("mb-3")
    var eventsCount = 0;
    events.forEach((event) => {
      if(event.available == available) {
        eventsCount += 1;
        availabilityContainer.append(this.renderEvent(event));
      }
    });
    if (available && eventsCount == 0) {
      availabilityContainer.insertAdjacentHTML("beforeend", `<p class="availability-title">${this.labelsValue.calendar.available_event_title}</p>`);
      availabilityContainer.insertAdjacentHTML("beforeend", `<div>${this.labelsValue.calendar.empty_state}</div>`);
    }
    if (eventsCount > 0) {
      availabilityContainer.insertAdjacentHTML("afterbegin", `<p class="availability-title">${this.renderDayAvailabilityTitle(eventsCount, available)}</p>`);
    }
    return availabilityContainer;
  }

  renderDayAvailabilityTitle(eventsCount, available) {
    if (available) {
      return eventsCount == 1 ? this.labelsValue.calendar.available_event_one : `${eventsCount} ${this.labelsValue.calendar.available_event_more}`;
    }else {
      return eventsCount == 1 ? this.labelsValue.calendar.not_available_event_one : `${eventsCount} ${this.labelsValue.calendar.not_available_event_more}`;
    }
  }

  renderEvent(event) {
    var eventCard = document.createElement("div");
    var available = event.available;
    eventCard.classList.add("event-card");
    eventCard.insertAdjacentHTML("beforeend", 
      ` 
      <div class="flag-img">${this.flagsImgValue[event.language]}</div>
      <div class="me-auto">
        <div class="duration-info">${event.duration_info}</div>
        <div class="lang-info">${event.language_label}</div>
      </div>
      <div class="availability-seats-info ${event.last_seats ? 'last-seats' : ''}">${event.status_label}</div>
      `
    );
    if(available == true) { 
      eventCard.addEventListener("click", () => { this.eventHandler(event) }); 
    }else{
      eventCard.classList.add("not-available");
    }
    return eventCard;
  }

  eventHandler(event) {
    if (this.bookingModificationValue) {
      this.modificationEventHandler(event)
    } else {
      this.bookEventHandler(event)
    }
  }

  modificationEventHandler(event) {
    this.setModificationParams(event);
    this.setModificationLabels(event);
    this.submitModificationBtn.classList.remove("disabled");
    window.modal_bsht_tour_session_selector_booking.desactivate();
  }

  setModificationParams(event) {
    this.modificationDateTarget.value = event.start_date.replace(/\-/g,'');
    this.modificationHourTarget.value = event.begins_time.replace(/\:/g,'');
    this.modificationLanguageTarget.value = event.language;
    this.modificationListingIdTarget.value = event.listing_id;
  }

  setModificationLabels(event) {
    const regex = new RegExp("src=\"(.*\/asset.*.png)\"", "g");
    const flagUrl = regex.exec(this.flagsImgValue[event.language])[1];
    document.querySelector("[data-calendar-week-selector='calendarWeekSelectorFlagImage']").src = flagUrl;
    const dateLabel = gon.moment(event.start_date).locale(gon.locale).format('ddd, D MMM YYYY').replace(/\./g,'');
    document.querySelector("[data-calendar-week-selector='calendarWeekSelectorStartsAtLabel']").textContent = `${dateLabel} - ${event.begins_time}h`;
    document.querySelector("[data-calendar-week-selector='calendarWeekSelectorLanguageLabel']").textContent = event.language_label;
  }

  bookEventHandler(event) {
    var date = event.start_date.replace(/\-/g,'');
    var hour = event.begins_time.replace(/\:/g,'');
    var controllerName = "booking/attendances"
    if (this.attendanceValue) {º
      controllerName = "bookings"
    }
    location.assign(`${location.origin}/${gon.locale}/${controllerName}/new?date=${date}&hour=${hour}&language=${event.language}&listing_id=${event.listing_id}`);
  }

  fetchEventData(monthDate, before, callback) {
    this.fetchTimetables(monthDate);
    this.fetchCalendars(monthDate, before, callback);
  }

  fetchTimetables(monthDate) {
    const urlTimetables = `${location.origin}/${gon.locale}/walks/${this.tourValue}/timetables?begins_at=${monthDate}`
    fetch(urlTimetables).then(response => {
      response.json().then(body => {
        this.eventsValue = Object.assign({}, this.eventsValue, body);
        this.renderEvents(monthDate);
      })
    })
    .catch(error => {
    })
  }

  fetchCalendars(monthDate, before, callback) {
    const urlCalendars = `${location.origin}/${gon.locale}/walks/${this.tourValue}/calendars?begins_at=${monthDate}`
    fetch(urlCalendars).then(response => {
      response.json().then(body => {
        this.eventDaysValue = Object.assign({}, this.eventDaysValue, body);
        this.renderHorizontalCalendar(monthDate, before);
        callback();   
      })
    })
    .catch(error => {
    })
  }

  changeView() {
    if(this.calendarViewWeek()) { this.setCalendarMonthView() };
  }

  setCalendarWeekView(){
    this.calendarView = "week";
    this.showMoreEventsTarget.classList.remove("d-none")
    this.chevronDownTarget.classList.remove("d-none");
    this.horizontalCalendarTarget.classList.remove("month-view");
    this.dayContainerTarget.classList.remove("month-view");
    this.showCurrentWeek();
    if (this.hasBottomWrapperTarget) {this.bottomWrapperTarget.classList.remove("bottom-wrapper-hidden");}
  }

  setCalendarMonthView(){
    this.calendarView = "month";
    this.showMoreEventsTarget.classList.add("d-none")
    this.loadNextMonth(() => this.initMonthViewCallback());
    this.loadPreviousMonth(() => this.initMonthViewCallback());
    if (this.hasBottomWrapperTarget) {this.bottomWrapperTarget.classList.add("bottom-wrapper-hidden");}
  }

  initMonthViewCallback() {
    this.chevronDownTarget.classList.add("d-none");
    this.unselectDayCalendar();
    this.dayContainerTarget.classList.add("month-view");
    this.horizontalCalendarTarget.classList.add("month-view");
    this.showCurrentMonth(this.lastDate);
  }

  calendarViewWeek() {
    return this.calendarView == "week";
  }

  showMoreEvents() {
    this.eventsContainerTarget.scrollTo({
      top: this.eventsContainerTarget.scrollTop + 70,
      behavior: 'smooth',
    });
  }

  displayShowMoreEvents() {
    if (this.eventsContainerTarget.offsetHeight + this.eventsContainerTarget.scrollTop >= this.eventsContainerTarget.scrollHeight) {
      this.showMoreEventsTarget.classList.remove("enabled");
    }else{
      this.showMoreEventsTarget.classList.add("enabled");
    }
  }

}

const application = Application.start()
application.register("calendar-week", CalendarWeekController)
